module.exports = __webpack_public_path__ + "static/media/edu-fair.766d3bcd.svg";